<div class="d-flex flex-column gap-3">
  <div class="d-flex align-items-center gap-2 justify-content-center">
    <img
      src="assets/Image/icons-donate/_verified-shield.svg"
      alt="Verified Shield Icon"
    />
    <h5 class="m-0">{{ titleKey | translate }}</h5>
  </div>

  <div class="line-divider"></div>

  <div class="d-flex align-items-center justify-content-between">
    <span>{{ 'CAMPAIGN.DonationAmount' | translate }}</span>
    <h5 class="fw-bold">
      {{ vm.donationAmount | currency:(vm.currency | uppercase):'symbol':'1.2-2' }}
      {{ vm.currency | uppercase }}
      <span *ngIf="vm.donationType === 'recurring'" class="fs-6">/mo</span>
    </h5>
  </div>

  <!-- Fee section: only shown after a valid API calculation -->
  <ng-container *ngIf="vm.hasCalculatedFees; else feePendingBlock">

    <div class="d-flex align-items-center justify-content-between">
      <span>{{ 'CAMPAIGN.TransactionFee' | translate }}</span>
      <span>
        {{ (vm.donationFees || 0) | currency:(vm.currency | uppercase):'symbol':'1.2-2' }}
        {{ vm.currency | uppercase }}
      </span>
    </div>

    <div class="card d-flex flex-column p-4 gap-2">
      <p class="m-0 text-muted small">{{ 'CAMPAIGN.FeeDescription' | translate }}</p>
      <div class="form-check d-flex flex-row align-items-center gap-2">
        <input
          class="form-check-input"
          type="checkbox"
          id="coverFees"
          [checked]="vm.feesCovered"
          (change)="onToggleCoverFees($any($event.target).checked)"
        />
        <label class="form-check-label small text-muted" for="coverFees">
          {{ 'CAMPAIGN.coverFee' | translate }}
        </label>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-between">
      <span>{{ 'CAMPAIGN.AmountCrezcoReceives' | translate }}</span>
      <span>
        {{ crezcoReceives | currency:(vm.currency | uppercase):'symbol':'1.2-2' }}
        {{ vm.currency | uppercase }}
      </span>
    </div>

    <div class="line-divider"></div>

    <div class="d-flex justify-content-between">
      <span class="fs-5">Total</span>
      <h4 class="fw-bold">
        {{ donationTotal | currency:(vm.currency | uppercase):'symbol':'1.2-2' }}
        {{ vm.currency | uppercase }}
        <span *ngIf="vm.donationType === 'recurring'" class="fs-6">/mo</span>
      </h4>
    </div>

  </ng-container>

  <!-- Fee pending/loading state -->
  <ng-template #feePendingBlock>
    <div class="card d-flex flex-column p-4 gap-2">

      <ng-container *ngIf="vm.isCalculatingFees; else feePending">
        <!-- Loading state while API call is in progress -->
        <div class="d-flex align-items-center gap-2 text-muted small">
          <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          <span>{{ 'CAMPAIGN.FeesCalculating' | translate }}</span>
        </div>
      </ng-container>

      <ng-template #feePending>
        <!-- Not yet calculated: show message + checkbox (no numbers) -->
        <p class="m-0 text-muted small">{{ 'CAMPAIGN.FeesPendingMessage' | translate }}</p>
        <div class="form-check d-flex flex-row align-items-center gap-2">
          <input
            class="form-check-input"
            type="checkbox"
            id="coverFees"
            [checked]="vm.feesCovered"
            (change)="onToggleCoverFees($any($event.target).checked)"
          />
          <label class="form-check-label small text-muted" for="coverFees">
            {{ 'CAMPAIGN.coverFee' | translate }}
          </label>
        </div>
      </ng-template>

    </div>
  </ng-template>

</div>
